import { DomainSchema } from "@/schemas/domain.schema";
import { getDomainById, updateBackupLimit } from "@/services/domains.service";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { z } from "zod";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";


export default function DomainDetailsPage() {
    const params = useParams();
    const domain_id = params?.domain_id as string;
    const [domain, setDomain] = useState<z.infer<typeof DomainSchema>>();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const inputRef = useRef<HTMLInputElement>(null);

    const getDomain = useCallback(async () => {
        const result = await getDomainById(domain_id as string);
        setDomain(() => result);
    }, [domain_id])

    useEffect(() => {
        getDomain();
    }, [getDomain]);

    const checkSubmit = async (domainID: string) => {
        setErrorMessage("");
        setSuccessMessage("");

        var refLimit = inputRef.current?.value ?? "";

        const formData = new FormData();
        formData.append("domainID", domainID);
        formData.append("limit", refLimit);

        try {
            const result = await updateBackupLimit(formData);
            if(result){
                setSuccessMessage("Setting updated");
            }
        } catch (error) {
            console.log(error);
            setErrorMessage("Couldn't update setting");
        }
    }

    return (
        <div className="flex-col">
            <h1 className="text-2xl font-semibold">{domain?.Name}</h1>
            <div>{domain?.Website}</div>
            <div className="py-2 px-4 w-[400px] border border-white rounded-md">
                    <Label className="text-lg mb-3 text-black dark:text-white">
                        Domain Backup Limit
                    </Label>
                    <Input
                        type="number"
                        name={domain?.ID}
                        id={"backupLimit-".concat(domain?.ID ?? "")}
                        defaultValue={domain?.BackupLimit}
                        className="form-control form-control-sm"
                        ref={inputRef}
                    />
                    {errorMessage != "" && (
                        <h1 className="w-full text-xl font-bold text-black dark:text-white mt-2 mb-2 py-1 px-2 rounded-md bg-red-500">
                            {errorMessage}
                        </h1>
                    )}
                    {successMessage != "" && (
                        <h1 className="w-full text-xl font-bold text-black dark:text-white mt-2 mb-2 py-1 px-2 rounded-md bg-green-500">
                            {successMessage}
                        </h1>
                    )}
                    <Button
                        type="button"
                        className="mt-3 bg-green-500 cursor-pointer"
                        disabled={domain?.ID == null}
                        onClick={async () => {
                        await checkSubmit(domain!.ID);
                    }}
                    >
                        Save
                    </Button>
            </div>
        </div>
    )
}